import { render, staticRenderFns } from "./RoleResponsibilitiesTable.vue?vue&type=template&id=d13e1dbe&scoped=true"
import script from "./RoleResponsibilitiesTable.vue?vue&type=script&lang=js"
export * from "./RoleResponsibilitiesTable.vue?vue&type=script&lang=js"
import style0 from "./RoleResponsibilitiesTable.vue?vue&type=style&index=0&id=d13e1dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e1dbe",
  null
  
)

export default component.exports